export { default as PhotoSolidIcon } from './PhotoSolidIcon';
